import { ListItem, TextField } from '@mui/material';

interface AddAnalysisToDashboardSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
export const AddAnalysisToDashboardSearch = ({
  searchQuery,
  setSearchQuery,
}: AddAnalysisToDashboardSearchProps) => {
  const onQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  return (
    <ListItem>
      <TextField
        fullWidth
        onKeyDown={(event) => event.stopPropagation()}
        color="primary"
        value={searchQuery}
        placeholder="Search Dashboards"
        onChange={onQueryChange}
        variant="standard"
      />
    </ListItem>
  );
};
